import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';
import Constants from '@utils/constants';
import { panelsAndDataViewsHistory } from '@queries/generated/audit.generated';

interface RecordProps {
    Panels: Array<{
        PanelRef: { $oid: string };
        DataViewRef?: { $oid: string };
    }>;
}

interface ControlsHubConfigPanelAuditLogGridProps {
    oldRecord: RecordProps;
    newRecord: RecordProps;
    oldItem?: Record<string, unknown>;
    newItem?: Record<string, unknown>;
    additionalInfo: panelsAndDataViewsHistory;
}

const propArray = ['H', 'ConfigId', 'CfId'];

const ControlsHubConfigPanelAuditLogGrid = ({
    oldRecord,
    newRecord,
    oldItem,
    newItem,
    additionalInfo,
}: ControlsHubConfigPanelAuditLogGridProps) => {
    const formatPanels = (recordData: { panelRef: string; dataViewRef?: string }, index: number) => {
        if (!recordData) {
            return null;
        }

        const panel = additionalInfo.panels?.find((el) => el?.id === recordData.panelRef);
        if (!panel) {
            return null;
        }
        let dataViewName = 'None';
        if (recordData.dataViewRef && recordData.dataViewRef !== Constants.ObjectId.Empty) {
            const dataView = additionalInfo.dataViewConfigurations?.find((dv) => dv?.id === recordData.dataViewRef);
            if (dataView?.name) dataViewName = dataView.name;
        }
        return `${index + 1}: ${panel.recordId} ${panel.graph?.plotTitle}, Data View Association: ${dataViewName}`;
    };

    const panelDataViewComparer = (
        oldItemValue: { panelRef: string; dataViewRef?: string },
        newItemValue: { panelRef: string; dataViewRef?: string },
    ) => {
        return oldItemValue.panelRef !== newItemValue.panelRef || oldItemValue.dataViewRef !== newItemValue.dataViewRef;
    };

    const arrayOfObjectsV2: any = {
        Panels: {
            valueResolver: formatPanels,
            compareField: 'panelRef',
            valueComparer: panelDataViewComparer,
        },
    };

    const refactorRecord = (auditRecord: Partial<RecordProps>) => {
        // Add empty Panels array to keep arrayOfObjectsV2 happy
        if (!auditRecord.Panels) {
            auditRecord.Panels = [];
        }
        return {
            ...auditRecord,
            ...removePropertiesFromObject(auditRecord, propArray),
            Panels: auditRecord.Panels.map((p) => {
                if (!p) return null;

                return {
                    // id: `${p.PanelRef.$oid}_${p.DataViewRef?.$oid}`,
                    panelRef: p.PanelRef.$oid,
                    dataViewRef: p.DataViewRef?.$oid,
                };
            }),
        } as Record<string, unknown>;
    };

    const refactoredOldRecord = refactorRecord(oldRecord);
    const refactoredNewRecord = refactorRecord(newRecord);

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            arrayOfObjectsV2,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export default ControlsHubConfigPanelAuditLogGrid;
